module.exports = __webpack_public_path__ + "static/media/choudry.2f6a09fb.jpg";